import { OffersWarrantyType, PricingDetailsFormValues } from "@dune/types";
import { usePricingDetailsForm } from "../../../../pricing/hooks/usePricingDetailsForm";
import { FormProvider } from "react-hook-form";
import { PricingDetailsForm } from "../../../../pricing/components/PricingDetailsForm";
import { useEffect, useRef } from "react";

type PricingDerogationFormProps = {
	warrantyType: OffersWarrantyType;
	pricingDetailsId: number;
	onPricingDetailsChange: (pricingDetails: PricingDetailsFormValues) => void;
};

export const PricingDerogationForm = ({
	warrantyType,
	pricingDetailsId,
	onPricingDetailsChange,
}: PricingDerogationFormProps) => {
	const { form } = usePricingDetailsForm({
		warrantyType,
		pricingDetailsId,
	});

	const { subscribe } = form;

	const onPricingDetailsChangeRef = useRef(onPricingDetailsChange);
	onPricingDetailsChangeRef.current = onPricingDetailsChange;

	useEffect(() => {
		const callback = subscribe({
			formState: {
				values: true,
			},
			callback: ({ values }) => {
				onPricingDetailsChangeRef.current(values);
			},
		});

		onPricingDetailsChangeRef.current(form.getValues());

		return () => callback();
	}, [subscribe, form]);

	return (
		<FormProvider {...form}>
			<PricingDetailsForm warrantyType={warrantyType} />
		</FormProvider>
	);
};
